(function () {
  'use strict';
  angular
    .module('directive.cdn', [])
    /* @ngInject */
    .directive('cdn', ["CdnService", function (CdnService) {
      return {
        restrict: 'A',
        priority: 100,
        scope: {
          cdnResponsiveSize: '@?',
          cdnSizes: '<?',
          cdnId: '@?',
          cdnSize: '@?',
          cdnDesignation: '@?',
          cdnExtension: '@?',
          cdnQuality: '@?',
          cdnAbsolute: '@?'
        },
        link: function (scope, element, attrs) {
          if (scope.cdnResponsiveSize && scope.cdnSizes) {
            var deregister = attrs.$observe('cdnResponsiveSize', function (size) {
              if (!scope.cdnSizes[size]) {
                if (angular.isDefined(attrs.lazyImg)) {
                  element.hasClass('loaded') ? element.attr('src', '') : attrs.$set('lazyImg', '');
                } else {
                  element.hasClass('loaded') ? element.attr('src', '') : attrs.$set('data-src', '');
                }
                return;
              }
              CdnService.get(
                scope.cdnSizes[size].id,
                scope.cdnSizes[size].size,
                scope.cdnDesignation,
                scope.cdnExtension,
                scope.cdnQuality,
                scope.cdnAbsolute
              )
              .then(function (res) {
                if (angular.isDefined(attrs.lazyImg)) {
                  element.hasClass('loaded') ? element.attr('src', res) : attrs.$set('lazyImg', res);
                } else {
                  element.hasClass('loaded') ? element.attr('src', res) : attrs.$set('data-src', res);
                }
                scope.$emit('imageLoaded');
              })
              .catch(function (err) {
                console.error(err);
              });
            });

            scope.$on('$destroy', deregister);
          } else {
            CdnService.get(
              scope.cdnId,
              scope.cdnSize,
              scope.cdnDesignation,
              scope.cdnExtension,
              scope.cdnQuality,
              scope.cdnAbsolute
            )
            .then(function (res) {
              if (angular.isDefined(attrs.lazyImg)) {
                element.hasClass('loaded') ? element.attr('src', res) : attrs.$set('lazyImg', res);
              } else {
                element.attr('src', res);
              }
              scope.$emit('imageLoaded');
            })
            .catch(function (err) {
              console.error(err);
            });
          }
        }
      };
    }]);
})();
